import {
  buildLayoutFromSections,
  createCriteriaSection,
} from "@/pages/admin/CriteriaPage/components/criteriaGridHelpers";

import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CriteriaService from "@services/CriteriaService";

export const createCriteria = createAsyncThunk(
  "criteria/create",
  async ({target}, {rejectWithValue}) => {
    try {
      const response = await CriteriaService.createCriteria({target});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialSection = createCriteriaSection();

export const current = {
  name: "",
  sections: [initialSection],
  sectionsLayout: buildLayoutFromSections([initialSection]),
};

const initialState = {
  target: current,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const createCriteriaSlice = createSlice({
  name: "create-criteria",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearCreate() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCriteria.pending, (state) => {
        pendingState(state);
      })
      .addCase(createCriteria.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(createCriteria.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setIsChanged, setTarget, setError, setStatus, clearCreate} =
  createCriteriaSlice.actions;

export default createCriteriaSlice.reducer;
